import sanitizeHtml from 'sanitize-html';
export const clearHtml = html =>
  sanitizeHtml(html, {
    allowedTags: [
      'a','b','br','div','font','h1','h2','h3','h4','h5','h6','head','hr','img','label','li','ol','p',
      'span','strong','table','td','th','tr','u','ul','style','script'
    ],
    allowComments: true,
    disallowedTagsMode: 'discard',
    // Remove 'script' from nonTextTags so JSON-LD content is not discarded
    nonTextTags: ['style', 'textarea', 'noscript'],
    allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel'],
    allowedAttributes: {
      a: ['href', 'name', 'target', 'class', 'id', 'style'],
      img: ['src', 'align', 'border', 'class', 'height', 'hspace', 'id', 'style', 'usemap', 'vspace', 'width'],
      b: ['class','id','style'],
      br: ['class','id','style'],
      div: ['align','class', 'dir','id','style'],
      font: ['class','color','face','size','id','style'],
      h1: ['align','class', 'dir','id','style'],
      h2: ['align','class', 'dir','id','style'],
      h3: ['align','class', 'dir','id','style'],
      h4: ['align','class', 'dir','id','style'],
      h5: ['align','class', 'dir','id','style'],
      h6: ['align','class', 'dir','id','style'],
      head: ['dir'],
      hr: ['align','size','width'],
      label: ['class','id','style'],
      li: ['class','dir','id','style','type'],
      ol: ['class','dir','id','style','type'],
      p: ['class','dir','id','style','align'],
      span: ['class','id','style'],
      strong: ['class','id','style'],
      table: ['align', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'class', 'dir', 'frame', 'id', 'rules', 'style', 'width'],
      td: ['abbr', 'align', 'bgcolor', 'class', 'colspan', 'dir', 'height', 'id', 'lang', 'rowspan', 'scope', 'style', 'valign', 'width'],
      th: ['abbr', 'align', 'background', 'bgcolor', 'class', 'colspan', 'dir', 'height', 'id', 'lang', 'scope', 'style', 'valign', 'width'],
      tr: ['align', 'bgcolor', 'class', 'dir', 'id', 'style', 'valign'],
      u: ['class', 'id', 'style'],
      ul: ['class', 'dir', 'id', 'style'],
      script: ['type']
    },
    exclusiveFilter: (frame) =>
      frame.tag === 'script' && frame.attribs.type !== 'application/ld+json'
  });

export default clearHtml;
